import { createActions } from "redux-actions";

export enum OperationConfigsActionTypes {
    REQUEST = 'OPERATION_CONFIGS_REQUEST',
    SUCCESS = 'OPERATION_CONFIGS_SUCCESS',
    FAILURE = 'OPERATION_CONFIGS_FAILURE',
    CLEAR = 'OPERATION_CONFIGS_CLEAR'
}
export enum OperationCreateActionTypes {
    REQUEST = 'OPERATION_CREATE_REQUEST',
    SUCCESS = 'OPERATION_CREATE_SUCCESS',
    FAILURE = 'OPERATION_CREATE_FAILURE',
    CLEAR = 'OPERATION_CREATE_CLEAR'
}

export enum OperationDetailsActionTypes {
    REQUEST = 'OPERATION_DETAILS_REQUEST',
    SUCCESS = 'OPERATION_DETAILS_SUCCESS',
    FAILURE = 'OPERATION_DETAILS_FAILURE',
    CLEAR = 'OPERATION_DETAILS_CLEAR'
}

export enum OperationListActionTypes {
    REQUEST = 'OPERATION_LIST_REQUEST',
    SUCCESS = 'OPERATION_LIST_SUCCESS',
    FAILURE = 'OPERATION_LIST_FAILURE',
    CLEAR = 'OPERATION_LIST_CLEAR'
}

export enum OperationDatasetAddActionTypes {
    REQUEST = 'OPERATION_DATASET_ADD_REQUEST',
    SUCCESS = 'OPERATION_DATASET_ADD_SUCCESS',
    FAILURE = 'OPERATION_DATASET_ADD_FAILURE',
    CLEAR = 'OPERATION_DATASET_ADD_CLEAR'
}

export enum AnalysisListActionTypes {
    REQUEST = 'ANALYSIS_LIST_REQUEST',
    SUCCESS = 'ANALYSIS_LIST_SUCCESS',
    FAILURE = 'ANALYSIS_LIST_FAILURE',
    CLEAR = 'ANALYSIS_LIST_CLEAR'
}

export enum AnalysisCreateActionTypes {
    REQUEST = 'ANALYSIS_CREATE_REQUEST',
    SUCCESS = 'ANALYSIS_CREATE_SUCCESS',
    FAILURE = 'ANALYSIS_CREATE_FAILURE',
    CLEAR = 'ANALYSIS_CREATE_CLEAR'
}

export enum AnalysisDatasetActionTypes {
    REQUEST = 'ANALYSIS_DATASET_REQUEST',
    SUCCESS = 'ANALYSIS_DATASET_SUCCESS',
    FAILURE = 'ANALYSIS_DATASET_FAILURE',
    CLEAR = 'ANALYSIS_DATASET_CLEAR'
}

export enum AnalysisDetailsActionTypes {
    REQUEST = 'ANALYSIS_DETAILS_REQUEST',
    SUCCESS = 'ANALYSIS_DETAILS_SUCCESS',
    FAILURE = 'ANALYSIS_DETAILS_FAILURE',
    CLEAR = 'ANALYSIS_DETAILS_CLEAR'
}

export enum AnalysisUpdateActionTypes {
    REQUEST = 'ANALYSIS_UPDATE_REQUEST',
    SUCCESS = 'ANALYSIS_UPDATE_SUCCESS',
    FAILURE = 'ANALYSIS_UPDATE_FAILURE',
    CLEAR = 'ANALYSIS_UPDATE_CLEAR'
}

export enum DWTAnalysisActionTypes {
    REQUEST = 'DWT_ANALYSIS_REQUEST',
    SUCCESS = 'DWT_ANALYSIS_SUCCESS',
    FAILURE = 'DWT_ANALYSIS_FAILURE',
    CLEAR = 'DWT_ANALYSIS_CLEAR'
}

export enum DWTTransformActionTypes {
    REQUEST = 'DWT_TRANSFORM_REQUEST',
    SUCCESS = 'DWT_TRANSFORM_SUCCESS',
    FAILURE = 'DWT_TRANSFORM_FAILURE',
    CLEAR = 'DWT_TRANSFORM_CLEAR'
}

export enum TrainingActionTypes {
    REQUEST = 'TRAINING_REQUEST',
    SUCCESS = 'TRAINING_SUCCESS',
    FAILURE = 'TRAINING_FAILURE',
    CLEAR = 'TRAINING_CLEAR'
}

export enum TrainingResultsActionTypes {
    REQUEST = 'TRAINING_RESULTS_REQUEST',
    SUCCESS = 'TRAINING_RESULTS_SUCCESS',
    FAILURE = 'TRAINING_RESULTS_FAILURE',
    CLEAR = 'TRAINING_RESULTS_CLEAR'
}

export enum analysisModelSelectionActionTypes {
    REQUEST = 'ANALYSIS_MODEL_SELECTION_REQUEST',
    SUCCESS = 'ANALYSIS_MODEL_SELECTION_SUCCESS',
    FAILURE = 'ANALYSIS_MODEL_SELECTION_FAILURE',
    CLEAR = 'ANALYSIS_MODEL_SELECTION_CLEAR'
}

export enum modelEvaluationActionTypes {
    REQUEST = 'MODEL_EVALUATION_REQUEST',
    SUCCESS = 'MODEL_EVALUATION_SUCCESS',
    FAILURE = 'MODEL_EVALUATION_FAILURE',
    CLEAR = 'MODEL_EVALUATION_CLEAR'
}

export enum selectedModelsActionTypes {
    REQUEST = 'SELECTED_MODELS_REQUEST',
    SUCCESS = 'SELECTED_MODELS_SUCCESS',
    FAILURE = 'SELECTED_MODELS_FAILURE',
    CLEAR = 'SELECTED_MODELS_CLEAR'
}

export enum favoriteModelsActionTypes {
    REQUEST = 'FAVORITE_MODELS_REQUEST',
    SUCCESS = 'FAVORITE_MODELS_SUCCESS',
    FAILURE = 'FAVORITE_MODELS_FAILURE',
    CLEAR = 'FAVORITE_MODELS_CLEAR'
}

export const {
    operationConfigsRequest,
    operationConfigsSuccess,
    operationConfigsFailure,
    operationConfigsClear,

    operationCreateRequest,
    operationCreateSuccess,
    operationCreateFailure,
    operationCreateClear,

    operationDetailsRequest,
    operationDetailsSuccess,
    operationDetailsFailure,
    operationDetailsClear,

    operationListRequest,
    operationListSuccess,
    operationListFailure,
    operationListClear,
    
    operationDatasetAddRequest,
    operationDatasetAddSuccess,
    operationDatasetAddFailure,
    operationDatasetAddClear,
    
    analysisListRequest,
    analysisListSuccess,
    analysisListFailure,
    analysisListClear,

    analysisCreateRequest,
    analysisCreateSuccess,
    analysisCreateFailure,
    analysisCreateClear,

    analysisDatasetRequest,
    analysisDatasetSuccess,
    analysisDatasetFailure,
    analysisDatasetClear,

    analysisDetailsRequest,
    analysisDetailsSuccess,
    analysisDetailsFailure,
    analysisDetailsClear,

    analysisUpdateRequest,
    analysisUpdateSuccess,
    analysisUpdateFailure,
    analysisUpdateClear,

    dwtAnalysisRequest,
    dwtAnalysisSuccess,
    dwtAnalysisFailure,
    dwtAnalysisClear,

    dwtTransformRequest,
    dwtTransformSuccess,
    dwtTransformFailure,
    dwtTransformClear,

    trainingRequest,
    trainingSuccess,
    trainingFailure,
    trainingClear,

    trainingResultsRequest,
    trainingResultsSuccess,
    trainingResultsFailure,
    trainingResultsClear,

    analysisModelSelectionRequest,
    analysisModelSelectionSuccess,
    analysisModelSelectionFailure,
    analysisModelSelectionClear,

    modelEvaluationRequest,
    modelEvaluationSuccess,
    modelEvaluationFailure,
    modelEvaluationClear,

    selectedModelsRequest,
    selectedModelsSuccess,
    selectedModelsFailure,
    selectedModelsClear,

    favoriteModelsRequest,
    favoriteModelsSuccess,
    favoriteModelsFailure,
    favoriteModelsClear,
} = createActions({
    [OperationConfigsActionTypes.REQUEST]: (payload) => payload,
    [OperationConfigsActionTypes.SUCCESS]: (payload) => payload,
    [OperationConfigsActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [OperationConfigsActionTypes.CLEAR]: () => { },

    [OperationCreateActionTypes.REQUEST]: (payload) => payload,
    [OperationCreateActionTypes.SUCCESS]: (payload) => payload,
    [OperationCreateActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [OperationCreateActionTypes.CLEAR]: () => { },

    [OperationDetailsActionTypes.REQUEST]: (payload) => payload,
    [OperationDetailsActionTypes.SUCCESS]: (payload) => payload,
    [OperationDetailsActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [OperationDetailsActionTypes.CLEAR]: () => { },

    [OperationListActionTypes.REQUEST]: (payload) => payload,
    [OperationListActionTypes.SUCCESS]: (payload) => payload,
    [OperationListActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [OperationListActionTypes.CLEAR]: () => { },

    [OperationDatasetAddActionTypes.REQUEST]: (payload) => payload,
    [OperationDatasetAddActionTypes.SUCCESS]: (payload) => payload,
    [OperationDatasetAddActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [OperationDatasetAddActionTypes.CLEAR]: () => { },

    [AnalysisListActionTypes.REQUEST]: (payload) => payload,
    [AnalysisListActionTypes.SUCCESS]: (payload) => payload,
    [AnalysisListActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [AnalysisListActionTypes.CLEAR]: () => { },

    [AnalysisCreateActionTypes.REQUEST]: (payload) => payload,
    [AnalysisCreateActionTypes.SUCCESS]: (payload) => payload,
    [AnalysisCreateActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [AnalysisCreateActionTypes.CLEAR]: () => { },

    [AnalysisDatasetActionTypes.REQUEST]: (payload) => payload,
    [AnalysisDatasetActionTypes.SUCCESS]: (payload) => payload,
    [AnalysisDatasetActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
    [AnalysisDatasetActionTypes.CLEAR]: () => { },

    [AnalysisDetailsActionTypes.REQUEST]: (payload) => payload,
    [AnalysisDetailsActionTypes.CLEAR]: () => { },
    [AnalysisDetailsActionTypes.SUCCESS]: (payload) => payload,
    [AnalysisDetailsActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [AnalysisUpdateActionTypes.REQUEST]: (payload) => payload,
    [AnalysisUpdateActionTypes.CLEAR]: () => { },
    [AnalysisUpdateActionTypes.SUCCESS]: (payload) => payload,
    [AnalysisUpdateActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [DWTAnalysisActionTypes.REQUEST]: (payload) => payload,
    [DWTAnalysisActionTypes.CLEAR]: () => { },
    [DWTAnalysisActionTypes.SUCCESS]: (payload) => payload,
    [DWTAnalysisActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [DWTTransformActionTypes.REQUEST]: (payload) => payload,
    [DWTTransformActionTypes.CLEAR]: () => { },
    [DWTTransformActionTypes.SUCCESS]: (payload) => payload,
    [DWTTransformActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [TrainingActionTypes.REQUEST]: (payload) => payload,
    [TrainingActionTypes.CLEAR]: () => { },
    [TrainingActionTypes.SUCCESS]: (payload) => payload,
    [TrainingActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [TrainingResultsActionTypes.REQUEST]: (payload) => payload,
    [TrainingResultsActionTypes.CLEAR]: () => { },
    [TrainingResultsActionTypes.SUCCESS]: (payload) => payload,
    [TrainingResultsActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [analysisModelSelectionActionTypes.REQUEST]: (payload) => payload,
    [analysisModelSelectionActionTypes.CLEAR]: () => { },
    [analysisModelSelectionActionTypes.SUCCESS]: (payload) => payload,
    [analysisModelSelectionActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [modelEvaluationActionTypes.REQUEST]: (payload) => payload,
    [modelEvaluationActionTypes.CLEAR]: () => { },
    [modelEvaluationActionTypes.SUCCESS]: (payload) => payload,
    [modelEvaluationActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [selectedModelsActionTypes.REQUEST]: (payload) => payload,
    [selectedModelsActionTypes.CLEAR]: () => { },
    [selectedModelsActionTypes.SUCCESS]: (payload) => payload,
    [selectedModelsActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),

    [favoriteModelsActionTypes.REQUEST]: (payload) => payload,
    [favoriteModelsActionTypes.CLEAR]: () => { },
    [favoriteModelsActionTypes.SUCCESS]: (payload) => payload,
    [favoriteModelsActionTypes.FAILURE]: ({ message }: any) => ({ error: message }),
})